import React from "react";
import { MessageBanner, MultiColumnList } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
export var ImportProgress = function (_a) {
    var progress = _a.progress;
    var formatMessage = useIntl().formatMessage;
    var bannerType = progress.status === "COMPLETED"
        ? "success"
        : progress.status === "FAILED"
            ? "error"
            : "default";
    if (progress.status === "DOWNLOADING") {
        return (React.createElement("div", null,
            React.createElement(MessageBanner, { type: "default" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.import.status.DOWNLOADING" }))));
    }
    var percentage = progress.totalRecords > 0
        ? Math.round((progress.currentRecord / progress.totalRecords) * 100)
        : 0;
    return (React.createElement("div", null,
        React.createElement(MessageBanner, { type: bannerType },
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.status.".concat(progress.status) })),
        React.createElement("div", { style: { margin: "16px 0" } },
            React.createElement("div", { style: {
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    height: "20px",
                } },
                React.createElement("div", { style: {
                        width: "".concat(percentage, "%"),
                        backgroundColor: progress.status === "FAILED" ? "#d32f2f" : "#1976d2",
                        height: "100%",
                        borderRadius: "4px",
                        transition: "width 0.3s ease",
                    } }))),
        React.createElement("div", { style: { marginBottom: "16px" } },
            progress.currentRecord,
            " / ",
            progress.totalRecords,
            " (",
            progress.successCount,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.successful" }),
            ",",
            " ",
            progress.missing1xxCount,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.missing1xx" }),
            ",",
            " ",
            progress.duplicateCount,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.duplicate" }),
            ",",
            " ",
            progress.failedCount,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.failed" }),
            ")"),
        progress.failedRecords && progress.failedRecords.length > 0 && (React.createElement(MultiColumnList, { contentData: progress.failedRecords, visibleColumns: ["recordNumber", "controlNumber", "errorMessage"], columnMapping: {
                recordNumber: "#",
                controlNumber: formatMessage({
                    id: "ui-br-agency.import.controlNumber",
                }),
                errorMessage: formatMessage({
                    id: "ui-br-agency.import.error",
                }),
            }, columnWidths: {
                recordNumber: "80px",
                controlNumber: "180px",
            } }))));
};
